import React from 'react';

import './style.scss';
import PropTypes from "prop-types";

export const TextImage = ({
                                className, reverse, title, text, linkText, linkUrl, image, video, videoPoster
                              }) => {
		return (
      <div className="TextImageContainer">
            <div className="container">
                <div className={`TextImage ${className} ${reverse ? "reverse" : ""}`} >
                    <div className="textContent">
                        {title &&
                            <h2 className="subtitle">{title}</h2>
                        }
                        {text &&
                            <p>{text}</p>
                        }
                        {linkText && linkUrl &&
                            <a className="PrimaryButton" href={linkUrl}>{linkText}</a>
                        }
                    </div>
                    {image &&
                        <img src={image} alt="" />
                    }
                    {video &&
                        <video src={video} controls poster={videoPoster} preload="none" />
                    }
                </div>
            </div>
      </div>
		);
}

TextImage.propTypes = {
  image: PropTypes.object.isRequired,
  reverse: PropTypes.bool
};

TextImage.defaultProps = {
  reverse: false
}
